/**
 * Central company information for the Miyin Global website.
 *
 * All display content that may change over time lives here, so contact
 * details, address or product copy can be updated in one place.
 */

export const company = {
  name: 'Miyin Global (Hong Kong) Limited',
  nameZh: '米映環球有限公司',
  slogan: 'Stories like tides, never end.',
  description:
    'Miyin Global (Hong Kong) Limited is a digital content company ' +
    'headquartered in Wan Chai, Hong Kong, dedicated to bringing ' +
    'high-quality web fiction and mobile reading experiences to readers ' +
    'around the world.',
  address: {
    line1: 'Flat/Rm A, 12/F, ZJ 300',
    line2: '300 Lockhart Road, Wan Chai',
    line3: 'Hong Kong',
  },
  // TODO: replace with the real contact details once available.
  contact: {
    email: 'contact@miyinglobal.com',
    phone: '+852 0000 0000',
  },
  founded: '',
};

export interface StoreLink {
  store: 'google-play' | 'app-store';
  label: string;
  // TODO: replace with the real store listing URLs once published.
  url: string;
}

export interface Product {
  name: string;
  tagline: string;
  description: string;
  features: { title: string; text: string }[];
  storeLinks: StoreLink[];
}

export const products: Product[] = [
  {
    name: 'TideRead',
    tagline: 'Web fiction app for global readers',
    description:
      'TideRead is a mobile novel application serving overseas markets. ' +
      'It brings thousands of licensed web novels - romance, fantasy, ' +
      'mystery and more - to readers anytime, anywhere, with a smooth ' +
      'reading experience tailored for each local market.',
    features: [
      {
        title: 'Vast Licensed Library',
        text: 'Thousands of novels across popular genres, continuously updated with new chapters every day.',
      },
      {
        title: 'Immersive Reading',
        text: 'A distraction-free reader with customizable fonts, themes and offline downloads.',
      },
      {
        title: 'Personalized Discovery',
        text: 'Smart recommendations that match every reader with stories they will love.',
      },
      {
        title: 'Global & Local',
        text: 'Multi-language content and localized experiences for readers across Southeast Asia, the Americas and Europe.',
      },
    ],
    storeLinks: [
      {
        store: 'google-play',
        label: 'Get it on Google Play',
        url: 'https://play.google.com/store/apps/details?id=com.miyinglobal.tideread',
      },
      {
        store: 'app-store',
        label: 'Download on the App Store',
        url: 'https://apps.apple.com/app/tideread/id000000000',
      },
    ],
  },
];

export const navigation = [
  { label: 'Products', href: '#products' },
  { label: 'About', href: '#about' },
];
